export default "__VITE_ASSET__CCLqv8NS__"